<template>
  <div
    v-if="$store.state.root.fileDownloadNotification"
    class="download-notification-backdrop"
  >
    <div class="download-notification">
      <lottie-player
        :src="fetchLottieJSON"
        background="transparent"
        speed="1"
        style="width: 100%; height: 110px"
        :loop="true"
        autoplay
      ></lottie-player>
    </div>
  </div>
</template>
<script>
import FileDownloadLoader from '@/assets/images/lottie/file-loader.json'

export default {
  data() {
    return {
      fileDownloadJSON: FileDownloadLoader
    }
  },
  computed: {
    fetchLottieJSON() {
      return JSON.stringify(this.fileDownloadJSON)
    }
  },
  watch: {
    // Watch the 'fileDownloadNotification' property from the store state
    '$store.state.root.fileDownloadNotification'(newVal, oldVal) {
      if (newVal) {
        const timer = setTimeout(() => {
          this.$store.dispatch('setDownloadNotification', {
            fileDownloadNotification: 0
          })
          clearTimeout(timer)
        }, 120000)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';

.download-notification-backdrop {
  background: #0000007f;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  .download-notification {
    margin: auto;
    margin-top: 300px;
    width: 500px;
    @media screen and (max-width: $tablet) {
      width: auto;
    }
    border-radius: 8px;
    .progression-bar {
      position: relative;
      border-radius: 12px;
      background: $noble-blue-50;
      width: 100%;
      height: 12px;
      .completion-bar {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        font-size: 8px;
        text-align: center;
        border-radius: 12px;
        color: $white;
        background: $wealthy-green-500;
        width: 30%;
      }
    }
  }
}
</style>
